import { css } from "styled-components";
import { CarouselProgressBar } from "../..";
export const leagueClientSkin = (chroma) => css `
  ${CarouselProgressBar} {
    .indicator {
      background-color: ${chroma.palette.gold3};
    }
  }
`;
//# sourceMappingURL=index.js.map